// @flow
import React, { Component } from 'react';

// import InputAutosuggest from '../InputAutosuggest';

import LazyLoad from 'react-lazyload';

export default class Err404 extends Component {
  render() {
    const ssr = (typeof this.props.ssr !== undefined && this.props.ssr) ? true : false;
    return (
      <div>
          <h1 className="white-text">404</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Err404/Err404.js